module.exports = __webpack_public_path__ + "img/sk.a5af0a28.svg";